import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { compose } from 'recompose'
import FormsyForm from 'formsy-react'
import { connect as connectStaticText } from '../../StaticText/connect'
import {
  AMBASSADORS_START_YEAR,
  currentYear,
  nextYear,
} from '../../../services/ambassadors/index'
import { Select } from '../../FormInput.v2/index'
import Button, { TYPES } from '../../Button/index'

/**
 * Get the correspondig options for the dropdown, depending on
 * the current year, will fill all the options from the
 * beginning to now.
 * @param {Boolean} withNextYear Should include next year or not
 * @returns {array}
 */
const getOptions = (withNextYear = false) => {
  const compareYear = withNextYear ? nextYear : currentYear
  const items = []
  let baseYear = AMBASSADORS_START_YEAR

  // only build up the year values
  while (baseYear <= compareYear) {
    items.push(baseYear)
    baseYear += 1
  }

  return items
    .reverse()
    .map((year) => (
      {
        value: `${year}`,
        label: `${year}`,
      }
    ))
}

/**
 * Format the output of the form to the submit func.
 * @param {String} value
 * @returns {Object}
 */
const formatValue = (value) => {
  if (!value) {
    return null
  }
  return value
}

/**
 * Render the component AmbassadorsYearDropdown
 *
 * @param {Object} props
 * @param {Function} props0.onSubmit
 * @param {Map} props0.staticText
 * @returns The complete AmbassadorsYearDropdown component
 */
const AmbassadorsYearDropdown = (props) => {
  const {
    buttonClass,
    onChange,
    onSubmit,
    staticText,
    withNextYear = false,
  } = props
  const options = getOptions(withNextYear)
  const defaultOption = withNextYear ? options[1] : options[0]

  const onSubmitHandler = (model) => {
    if (onSubmit) {
      onSubmit(formatValue(model.select || defaultOption.value))
    }
  }

  // Changed due to an issue with several events fired by FormsyForm onChange event
  // This resulted in multiple requests being sent when the year is changed
  // Select onChange handler is used instead
  const onChangeHandler = (value) => {
    if (onChange) {
      onChange(formatValue(value || defaultOption.value))
    }
  }

  return (
    <FormsyForm
      className="ambassadors-year-dropdown"
      onValidSubmit={onSubmitHandler}
      noValidate
    >
      <div className="ambassadors-year-dropdown__select-wrapper">
        <Select
          name="select"
          value={defaultOption.value}
          placeholder={defaultOption.value}
          label={staticText.getIn(['data', 'yearPlaceholder'])}
          onChange={onChangeHandler}
        >
          {options.map((option, index) => (
            <option key={`year-${index}`} value={option.value}>{option.label}</option>
          ))}
        </Select>
      </div>
      <Button
        type={TYPES.SECONDARY}
        submit
        className={`ambassadors-year-dropdown__submit-btn ${buttonClass || ''}`}
      >
        {staticText.getIn(['data', 'buttonDownload'])}
      </Button>
    </FormsyForm>
  )
}

AmbassadorsYearDropdown.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  buttonClass: PropTypes.string,
}

export default compose(
  connectStaticText({ storeKey: 'ambassadorsYearDropdown' }),
)(AmbassadorsYearDropdown)
